/* @flow */
import * as React from "react";
import { withColorsProvider, type ColorSet } from "../ColorsProvider";
import prefixStyles from "../utils/prefixStyles";
import SliderTooltip from "./SliderTooltip";
import Bar from "./Bar";
import Handle from "./Handle";

type Props = {
  captureRef: (?HTMLElement) => void,
  ariaValues: {
    min: number,
    max: number,
    value: number,
  },
  isHeat: ?boolean,
  isCool: ?boolean,
  isBeingDragged: boolean,
  hasOffState: boolean,
  ratio: number,
  showValueAboveHandle: boolean,
  fullSliderWidth: ?number,
  tooltipLabel: string,
  tooltipStyle: ?Object,
  onMouseDown: (MouseEvent) => void,
  onTouchStartCapture: (TouchEvent) => void,
  colors: ColorSet,
};

class SliderPresenter extends React.Component<Props> {
  _getColor() {
    const { isHeat, isCool, colors } = this.props;

    let color = colors.PRIMARY;

    if (isHeat) {
      color = colors.HEAT;
    } else if (isCool) {
      color = colors.COOL;
    }

    return color;
  }

  render() {
    const {
      captureRef,
      ariaValues,
      isBeingDragged,
      hasOffState,
      ratio,
      showValueAboveHandle,
      fullSliderWidth,
      tooltipLabel,
      tooltipStyle,
      onMouseDown,
      onTouchStartCapture,
      colors,
    } = this.props;

    const color = this._getColor();

    const styles = {
      wrapper: prefixStyles({
        display: "flex",
        alignItems: "center",
      }),
      popUpTooltip: {
        fontSize: 16,
        lineHeight: "normal",
        color: colors.HEADER_BACKGROUND,
        padding: ".5em",
        textAlign: "center",
      },
      valueTooltip: {
        lineHeight: 1.2,
        fontSize: 10,
        color: colors.LABEL,
      },
    };

    const wrapperStyle = {
      ...styles.wrapper,
      paddingTop: showValueAboveHandle ? 15 : 0,
    };
    const popUpTooltipStyle = {
      ...styles.popUpTooltip,
      backgroundColor: color,
      ...tooltipStyle,
    };

    let tooltips = [
      <SliderTooltip
        key="pop-up"
        isVisible={isBeingDragged}
        sliderWidth={fullSliderWidth}
        label={tooltipLabel}
        ratio={ratio}
        style={popUpTooltipStyle}
      />,
    ];
    if (showValueAboveHandle) {
      tooltips.push(
        <SliderTooltip
          key="value"
          isVisible={!isBeingDragged}
          sliderWidth={fullSliderWidth}
          isPersistentValue
          label={tooltipLabel}
          ratio={ratio}
          style={styles.valueTooltip}
        />
      );
    }

    return (
      <div
        data-component-name="SliderPresenter"
        style={wrapperStyle}
        onMouseDown={onMouseDown}
        onTouchStartCapture={onTouchStartCapture}
        ref={captureRef}
      >
        <Bar color={color} size={ratio} />
        <Handle
          color={color}
          tooltip={tooltips}
          isMinimum={hasOffState && ratio === 0}
          role="slider"
          aria-valuenow={ariaValues.value}
          aria-valuetext={tooltipLabel}
          aria-valuemin={ariaValues.min}
          aria-valuemax={ariaValues.max}
        />
        <Bar size={1 - ratio} />
      </div>
    );
  }
}

export default withColorsProvider(SliderPresenter);



// WEBPACK FOOTER //
// ../nx-components/src/Slider/SliderPresenter.jsx